import {DossierInterface} from '../../class/api/Dossier';
import {RapportScientifiqueEmbedInScheduling} from './RapportScientifique';

export enum RapportScientifiqueSchedulingStatut {
    aVenir = 'a_venir',
    aSaisir = 'a_saisir',
    enCours = 'en_cours',
    valide = 'valide',
    expertise = 'expertise',
    traite = 'traite',
}

export interface RapportScientifiqueScheduling {
    '@id'?: string;

    dossier: DossierInterface;
    rapportScientifique?: RapportScientifiqueEmbedInScheduling;

    rapportScientifiqueConfiguration;
    rapportScientifiqueConfigurationDossier;

    dateOuverture: string;
    dateOuvertureCalcul: string;

    dateRemise: string;
    dateRemiseCalcul: string;

    statut: RapportScientifiqueSchedulingStatut;

    activityCommentsTarget: string;
    hasOpenTask: boolean;
    exclu: boolean;
}
